import { DateTime } from 'luxon';

// Return 2:00 AM
const displayTimeWithAmPm = (dateTime) => {
  const luxonDateTime = DateTime.fromJSDate(dateTime);
  return luxonDateTime.toFormat('hh:mm a');
};

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Return Sat, Nov 19, 10:30 AM
const displayTimeStringWithoutYear = (dateTime) => {
  const luxonDateTime = DateTime.fromJSDate(dateTime);
  const weekday = dayNames[luxonDateTime.weekday];
  const monthName = monthNames[luxonDateTime.month - 1];
  return `${weekday}, ${monthName} ${luxonDateTime.day}, ${displayTimeWithAmPm(dateTime)}`;
};

// Return Nov 19, 2022
const displayTimeStringDate = (dateTime) => {
  const luxonDateTime = DateTime.fromJSDate(dateTime);
  const monthName = monthNames[luxonDateTime.month - 1];
  return `${monthName} ${luxonDateTime.toFormat('dd, yyyy')}`;
};

export { displayTimeStringWithoutYear, displayTimeStringDate, displayTimeWithAmPm };
